// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"be9dbea6","4127":"bfaca21e","9522":"e082e68e"}[chunkId] + ".chunk.css";
};